import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-grey-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_items_loader = _resolveComponent("async-items-loader")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _component_mini_pagination = _resolveComponent("mini-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_async_items_loader, {
      task: _ctx.task,
      "num-items": _ctx.users.length,
      class: "q-mb-sm"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" No users found. ")
      ]),
      _: 1
    }, 8, ["task", "num-items"]),
    _createVNode(_component_q_markup_table, { class: "full-width" }, {
      default: _withCtx(() => [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: user.id
            }, [
              _createElementVNode("td", null, [
                _createVNode(_component_q_checkbox, {
                  "model-value": _ctx.isSelected(user.id),
                  "onUpdate:modelValue": ($event: any) => (_ctx.toggleSelect(user))
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _createElementVNode("td", null, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
              _createElementVNode("td", _hoisted_1, _toDisplayString(user.email), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_mini_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
      total: _ctx.total,
      "per-page": _ctx.limit,
      class: "q-mt-md"
    }, null, 8, ["modelValue", "total", "per-page"])
  ]))
}